interface RemoveKeys {
  <T extends object, K extends (keyof T)[]>
  (object: T, ...keys: K): {
    [ K2 in Exclude<keyof T, K[number]>]: T[K2]
  }
}

const removeKeys: RemoveKeys = (object, ...keys) => {
  const copy = Object.assign({}, object)

  for (let key of keys) {
    delete copy[key]
  }

  return copy
}


export default {
  removeKeys,
}
